const UpdateChannelTypes = {
    1: "Application",
    2: "Settings"
};
Object.freeze(UpdateChannelTypes);

export { UpdateChannelTypes }